module.exports = __webpack_public_path__ + "img/logo__login.32fadf86.svg";